import { QueryClient } from '@tanstack/react-query';

import { isRetryableApiError } from '#/lib/api-client';

const DEFAULT_QUERY_RETRY_LIMIT = 3;

export function shouldRetryQuery(failureCount: number, error: unknown) {
  return isRetryableApiError(error) && failureCount < DEFAULT_QUERY_RETRY_LIMIT;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
    },
  },
});
